import { createContext, useContext, useEffect, useState } from 'react';

const ThemeProviderContext = createContext({ theme: 'system', setTheme: () => null });

const ThemeProvider = ({ children, defaultTheme = 'system', storageKey = 'admin-ui-theme' }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem(storageKey) || defaultTheme);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      root.classList.add(systemTheme);
    } else {
      root.classList.add(theme);
    }
  }, [theme]);

  const value = {
    theme,
    setTheme: (newTheme) => {
      localStorage.setItem(storageKey, newTheme);
      setTheme(newTheme);
    }
  };

  return <ThemeProviderContext.Provider value={value}>{children}</ThemeProviderContext.Provider>;
};

const useTheme = () => useContext(ThemeProviderContext);

export { ThemeProvider, useTheme };
